// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M20 2.91309V17.9999C20 19.6567 18.6569 20.9999 17 20.9999C15.3431 20.9999 14 19.6567 14 17.9999C14 16.343 15.3431 14.9999 17 14.9999C17.3506 14.9999 17.6872 15.06 18 15.1706V8.08669L8 8.92002V18.9999C8 20.6567 6.65685 21.9999 5 21.9999C3.34315 21.9999 2 20.6567 2 18.9999C2 17.343 3.34315 15.9999 5 15.9999C5.35064 15.9999 5.68722 16.06 6 16.1706V4.07975L20 2.91309Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-music-filled')
export default class MusicFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'music-filled',
    }
  }
}
